import { useSelector } from "react-redux";
import { utilsState } from "../../../sotre/redux/features/utilsSlice";
import DateInput from "../../../components/common/inputs/DateInput";
import UserModal from "../../../components/common/modals/user-modal/UserModal";
import { useRef, useState } from "react";
import {
  errorMessage,
  successMessage,
} from "../../../utils/toastify-message/ToastifyMessage";
import { PiXFill } from "react-icons/pi";

export default function UserReportsFilter({
  filterDataHandler,
  activeSearchButton,
}) {
  const { utils } = useSelector(utilsState);
  const userModalRef = useRef();
  const [filters, setFilters] = useState({});
  const [user, setUser] = useState(null);

  const handleUser = (data) => {
    setUser(data.name);
    successMessage(`کاربر ${data?.name} انتخاب شد`);
    setFilters({ ...filters, user: data?._id });
  };

  const deleteUser = () => {
    setUser("");
    setFilters({ ...filters, user: "" });
  };
  const handleSearchClick = () => {
    if (!filters.role) {
      errorMessage("حداقل یک نقش انتخاب کنید");
    }
    filterDataHandler({ ...filters });
  };
  return (
    <div className="w-full flex flex-col flex-wrap my-8 gap-6 px-6">
      <UserModal ref={userModalRef} handleUser={handleUser} />

      <div className="w-full flex flex-col sm:flex-row gap-6">
        <DateInput
          label={"از تاریخ"}
          onChange={(e) => setFilters({ ...filters, from: e })}
        />
        <DateInput
          label={"تا تاریخ"}
          onChange={(e) => setFilters({ ...filters, to: e })}
        />
        <div className="flex flex-col">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            برند
          </label>
          <select
            onChange={(e) => setFilters({ ...filters, brand: e.target.value })}
            id="brand"
            className="bg-white text-center sm:text-right border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value={""} selected>
              همه
            </option>
            <option value={"saboora"}>صبورا</option>
            <option value={"attarbashi"}>عطارباشی</option>
          </select>
        </div>
        <div className="flex flex-col">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            نقش
          </label>
          <select
            onChange={(e) => setFilters({ ...filters, role: e.target.value })}
            id="province"
            className="bg-white text-center sm:text-right border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value={""} selected>
              انتخاب نقش
            </option>
            {utils
              ? utils.ROLES_VALUES.map((item) => {
                  return <option value={item.value}>{item?.name}</option>;
                })
              : null}
          </select>
        </div>
        <div className="relative">
          <span
            onClick={() => userModalRef?.current?.showModal()}
            className="absolute w-full h-full"
          ></span>
          {user ? (
            <PiXFill
              className=" cursor-pointer absolute left-2 bottom-4 text-red-500"
              onClick={deleteUser}
            />
          ) : null}
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            انتخاب کاربر
          </label>
          <input
            value={user}
            onChange={(e) => setUser(e.target.value)}
            disabled
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          />
        </div>
        <button
          disabled={!activeSearchButton}
          onClick={handleSearchClick}
          className="text-white mt-[30px] h-10 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-8  text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
        >
          {activeSearchButton ? "جستجو" : "منتظر بمانید..."}
        </button>
      </div>
    </div>
  );
}
